<template>
  <div class="form-main-container">
    <div class="form-inner-container">
      <slot></slot>
    </div>
  </div>
</template>
